<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
	  <ProductionOutMenu></ProductionOutMenu>
        <div class="widget-heading">
          <div class="row align-items-center">
            <div class="col d-flex align-items-center">
              <h4 class="me-3 my-0">Produkcja - zlecenia zewnętrzne</h4>
              <button v-if="hasPermission('canAddProdukcjaOut')" @click="addProductionOut"
                      class="btn btn-primary btn-sm me-3"><i class="bi bi-plus-circle me-2"></i>Dodaj pozycję
              </button>
            </div>
            <div class="col-auto d-flex align-items-center">
              <div class="form-check form-switch form-switch-success d-flex align-items-center">
                <input class="form-check-input" type="checkbox" role="switch" id="showArchivedPrOut"
                       style="height:1.5em; width:3em;" v-model="archivedPrOutShown">
                <label class="form-check-label ms-2 mb-0" for="showArchivedPrOut">Pokaż zarchiwizowane</label>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row">
            <div class="custom-table col-md-6">
              <div class="row mb-3">
                <div class="col-6">
                  <input v-model="searchQuery" class="form-control form-sm" placeholder="Szukaj po nazwie...">
                </div>
                <div class="col-6 text-end">
                  <label>Liczba rekordów na stronie: </label>
                  <select v-model.number="pageSize" class="form-select form-sm d-inline w-auto ms-2">
                    <option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option>
                  </select>
                </div>
              </div>
              <div class="table-responsive">
                <table v-if="addingNew" id="production-out-add-table" class="table table-hover">
                  <thead>
                  <tr>
                    <th>Nazwa</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td><input v-model="newProductionOut.name" class="form-control"/></td>
                    <td>
                      <button v-if="hasPermission('canAddProdukcjaOut')" @click="saveNewProductionOut"
                              class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2 equal-width-btn"></i>Zapisz
                      </button>
                      <button @click="cancelProductionOut" class="btn btn-sm btn-danger"><i
                          class="bi bi-x-circle me-2 equal-width-btn"></i>Anuluj
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table id="production-out-table" class="table table-hover">
                  <thead>
                  <tr>
                    <th>#</th>
                    <th @click="changeSort('name')" style="cursor:pointer;">Nazwa</th>
                    <th @click="changeSort('sumawyliczona')" style="cursor:pointer;">Wartość</th>
                    <th @click="changeSort('created_at')" style="cursor:pointer;">Utworzono</th>
                    <th>Akcje</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(productionout, pid) in paginatedProductionOut" :key="productionout.id">
                    <td>{{ pid + 1 + (currentPage - 1) * pageSize }}</td>
                    <td>
                      <input v-if="editingId === productionout.id && hasPermission('canEditProdukcjaOut')"
                             v-model="productionout.name" class="form-control"/>
                      <span v-else @click="selectProductionOut(productionout)"
                            style="cursor:pointer; color:blue;">{{ productionout.name }}</span>
                    </td>
                    <td v-if="productionout.archived == 0">{{ formatMoney(productionout.sumawyliczona ?? 0) }}</td>
                    <td v-else>(archiwum)</td>
                    <td>{{ formatDate(productionout.created_at) }}</td>
                    <td>
                      <a :href="route('production.out.show', {id: productionout.id })"
                         class="btn btn-info btn-sm me-2 mb-2 equal-width-btn"><i class="bi bi-url"></i>
                        &nbsp;Przejdź</a>
                      <button v-if="editingId === productionout.id && hasPermission('canEditProdukcjaOut')"
                              @click="updateProductionOut(productionout)" class="btn btn-sm btn-success mb-2 me-2">
                        Zapisz
                      </button>
                      <button v-else v-if="hasPermission('canEditProdukcjaOut')"
                              @click="editProductionOut(productionout.id)"
                              class="btn btn-sm btn-outline-info me-2 mb-2 "><i
                          class="bi bi-pencil equal-width-btn"></i>Edytuj
                      </button>
                      <button v-if="hasPermission('canDelProdukcjaOut')" @click="deleteProductionOut(productionout.id)"
                              class="btn btn-sm btn-danger"><i class="bi bi-trash me-2 equal-width-btn"></i>Usuń
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
              <nav aria-label="Page navigation">
                <ul class="pagination justify-content-center mt-3">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Poprzednia</a>
                  </li>

                  <li class="page-item" v-for="page in totalPages" :key="page"
                      :class="{ active: page === currentPage }">
                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Następna</a>
                  </li>
                </ul>
              </nav>
            </div>

            <div class="col-md-6" v-if="selectedProductionOut">
              <h4>{{ selectedProductionOut.name }}</h4>
              <table class="table table-bordered table-hover">
                <thead>
                <tr>
                  <th class="bg-gray-100">#</th>
                  <th class="bg-gray-100">Kontrahent</th>
                  <th class="bg-gray-100">
                    Cena ustalona
                    <button type="button" class="btn btn-link p-0 ms-0" data-bs-toggle="modal"
                            data-bs-target="#infoModal"
                            style="width:22px; height:20px; border-radius:50%; border:none; background:#e2e6ea; cursor:pointer;">
                      <i class="bi bi-info-circle"></i></button>
                  </th>

                  <th class="bg-gray-100">
                    Cena wyliczona
                    <button type="button" class="btn btn-link p-0 ms-0" data-bs-toggle="modal"
                            data-bs-target="#infoModal2"
                            style="width:22px; height:20px; border-radius:50%; border:none; background:#e2e6ea; cursor:pointer;">
                      <i class="bi bi-info-circle"></i></button>
                  </th>
                  <th class="bg-gray-100">Różnica (%)</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(producer, idx) in selectedProductionOutProducers" :key="producer.id">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ producer.short_name }}</td>
                  <td><span v-if="hasPermission('canEditProdukcjaOut')" @click="openCenaModal(producer)"
                            style="cursor:pointer; color:blue;">{{ formatMoney(producer.cena_ustalona ?? 0) }}</span>
                    <span v-else>{{ formatMoney(producer.cena_ustalona ?? 0) }}</span>
                  </td>
                  <td>{{ formatMoney(producer.wartosc_wyliczona ?? 0) }}</td>
                  <td><span v-if="producer.wartosc_wyliczona >0 && producer.cena_ustalona !== null">{{
                      formatMoney(((producer.wartosc_wyliczona - producer.cena_ustalona) / producer.wartosc_wyliczona) * -100 ?? 0)
                    }}</span><span v-else>0</span>%
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="bg-gray-100"><strong>RAZEM:</strong></td>
                  <td class="bg-gray-100"><strong>{{ formatMoney(razemustalona ?? 0) }}</strong></td>
                  <td class="bg-gray-100"><strong>{{ formatMoney(razemwyliczona ?? 0) }}</strong></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>SUMA:</strong></td>
                  <td><strong>{{ formatMoney(suma) }}</strong></td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="infoModalLabel">Cena ustalona</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
                  </div>
                  <div class="modal-body">
                    Cena ustalona to kwota ustalona z wykonawcą na wykonanie zamówienia.
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal fade" id="infoModal2" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="infoModalLabel">Cena wyliczona</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
                  </div>
                  <div class="modal-body">
                    Cena wyliczona to suma iloczynu wszystkich wybranych pozycji (ilość * cena za sztukę).
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="isModalOpen" class="modal fade show" tabindex="-1"
                 style="display: block; background: rgba(0,0,0,0.5);">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Edycja Cena ustalona</h5>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                  </div>
                  <div class="modal-body">
                    <input v-model.number="editedValue" type="number" class="form-control"/>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                    <button type="button" class="btn btn-primary" @click="saveCenaUstalona">Zapisz</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import ProductionOutMenu from "@/Pages/ProductionOut/parts/ProductionOutMenu.vue";
const {hasPermission} = usePermission();

export default {
  components: {AppLayout, hasPermission, ProductionOutMenu},
  props: {
    users: Object,
    production_out: Array, 
	
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      archivedPrOutShown: false,
      selectedProductionOut: null,
      isModalOpen: false,
      editedValue: null,
      editedProducer: null,
      editedField: null,
      selectedProductionOutProducers: [],
      newProductionOut: this.getEmptyForm(),
      currentPage: 1,
      searchQuery: '',
      pageSizeOptions: [10, 20, 50, 100],
      pageSize: 10,
      sortColumn: 'created_at',
      sortDirection: 'desc',
    };
  },
  watch: {
    pageSize(newSize, oldSize) {
      this.adjustCurrentPage();
    },
    filteredProductionOut() {
      this.adjustCurrentPage();
    }
  },
  computed: {

    suma() {
      return this.selectedProductionOutProducers.reduce((acc, producer) => {
        let cenaUstalona = producer.cena_ustalona;

        if (typeof cenaUstalona === 'string') {
          cenaUstalona = cenaUstalona.replace(',', '.');
        }
        const cenaNum = parseFloat(cenaUstalona);

        if (!isNaN(cenaNum) && cenaNum > 0) {
          return acc + cenaNum;
        }

        let wartoscWyliczona = producer.wartosc_wyliczona ?? 0;
        if (typeof wartoscWyliczona === 'string') {
          wartoscWyliczona = wartoscWyliczona.replace(',', '.');
        }
        const wartoscNum = parseFloat(wartoscWyliczona);

        return acc + (isNaN(wartoscNum) ? 0 : wartoscNum);
      }, 0);
    },

    razemustalona() {
      return this.selectedProductionOutProducers.reduce((sum, item) => {
        let val = item.cena_ustalona;

        if (typeof val === 'string') {
          val = val.replace(',', '.');
        }

        const number = parseFloat(val);
        return sum + (isNaN(number) ? 0 : number);
      }, 0);
    },
    razemwyliczona() {
      return this.selectedProductionOutProducers.reduce((sum, item) => {
        let val = item.wartosc_wyliczona ?? 0;

        if (typeof val === 'string') {
          val = val.replace(',', '.');
        }

        const number = parseFloat(val);
        return sum + (isNaN(number) ? 0 : number);
      }, 0);
    },

    filteredProductionOut() {
      let data = this.archivedPrOutShown
          ? this.production_out
          : this.production_out.filter(po => !po.archived);

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        data = data.filter(po => po.name.toLowerCase().includes(query));
      }

      return data;
    },

    sortedProductionOut() {
      let data = [...this.filteredProductionOut];

      if (!this.sortColumn) return data;

      return data.sort((a, b) => {
        let valA = a[this.sortColumn];
        let valB = b[this.sortColumn];

        if (this.sortColumn === 'created_at') {
          valA = new Date(valA);
          valB = new Date(valB);
        } else if (this.sortColumn === 'sumawyliczona') {
          valA = parseFloat(valA) || 0;
          valB = parseFloat(valB) || 0;
        } else { // np. 'name'
          valA = String(valA).toLowerCase();
          valB = String(valB).toLowerCase();
        }

        if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
        if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    },

    paginatedProductionOut() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedProductionOut.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.sortedProductionOut.length / this.pageSize);
    }

  },
  methods: {

    adjustCurrentPage() {
      const totalPages = Math.ceil(this.sortedProductionOut.length / this.pageSize);
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages || 1; // jeśli totalPages = 0, ustawiamy na 1
      }
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
    changeSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },

    openCenaModal(producer) {
      this.editedProducer = producer;
      this.editedField = 'cena_ustalona';
      this.editedValue = producer.cena_ustalona ?? 0;
      this.isModalOpen = true;
    },

    closeModal() {
      this.isModalOpen = false;
      this.editedValue = null;
      this.editedProducer = null;
      this.editedField = null;
    },

    saveCenaUstalona() {
      if (!this.editedProducer) return;

      this.$inertia.post(
          route('production.out.updateCenaUstalona'),
          {
            customer_id: this.editedProducer.id,
            prid: this.selectedProductionOut.id,
            cena_ustalona: this.editedValue
          },
          {
            onSuccess: () => {
              this.editedProducer.cena_ustalona = this.editedValue;
              this.closeModal();
            },
            onError: (errors) => {
              alert('Wystąpił błąd przy zapisie');
              console.error(errors);
            }
          }
      );
    },

    async selectProductionOut(productionout) {
      this.selectedProductionOut = productionout;
      try {
        const response = await axios.get(route('production.out.producers', productionout.id));
        this.selectedProductionOutProducers = response.data.producers;
      } catch (error) {
        console.error('Błąd przy pobieraniu kontrahentów:', error);
      }
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },

    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },

    addProductionOut() {
      this.addingNew = true;
      this.newProductionOut = this.getEmptyForm();
    },

    cancelProductionOut() {
      this.addingNew = false;
      this.newProductionOut = this.getEmptyForm();
    },

    editProductionOut(id) {
      this.editingId = id;
    },

    updateProductionOut(productionout) {
      this.$inertia.put(route('production.out.update', productionout.id), productionout, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },

    saveNewProductionOut() {
      this.$inertia.post(route('production.out.store'), this.newProductionOut, {
        onSuccess: () => {
          this.addingNew = false;
          this.newProductionOut = this.getEmptyForm();
        }
      });
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },

    deleteProductionOut(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie  wpisu',
        html: 'Czy na pewno chcesz usunąć wybraną pozycję i wszystkie jej dane?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('production.out.destroy', id));
        }
      })
    }
  }
}
</script>
<style scoped>
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
</style>